import {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  SelectWrapper,
  InputTextWrapper,
  InputNumberWrapper,
} from '../../../../../../components/UI/Form/Input'
import HeaderTitle from '../../../componentes/Form/Header'
import {getPointById, getSupplier} from '../../../../services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import {PointModel, SelectModel, SupplierModel} from '../../../../model'
import {TITLE_FORM_POINT} from '../../../../util/Constants'
import {initValues} from '../../../../util/values/point'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import {useCompany, useCamp, useClient, useSite} from '../../../../../central/hooks'
import {useTableMaster} from '../../../../hooks'
import {clearFields} from '../../../../../../util/functions'
import {Switch} from '../../../../../../components/UI/Switch'
const Point: FC = () => {
  const {
    setError,
    setValue,
    reset,
    watch,
    register,
    formState: {errors},
  } = useFormContext()
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])
  const [supplier, setSupplier] = useState<SelectModel[]>([])
  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()
  const {getCampFD} = useCamp()
  const {typeAdmin, getTypeAdminList, statusUser, getStatusUserList} = useTableMaster()

  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    if (response.length === 1) {
      setValue('companiaId', response[0].value)
      setError('companiaId', {})
      await getClientList(response[0].value as string)
    }

    setCompany(response)
  }
  const getClientList = async (companyId: string) => {
    const response = await getClientFD({companiaId: companyId})
    if (response.length === 1) {
      setValue('clienteId', response[0].value)
      setError('clienteId', {})
      await getSiteList(response[0].value as string)
    }
    setClients(response)
  }
  const getSiteList = async (clientId: string) => {
    const response = await getSiteFD({clienteId: clientId})
    if (response.length === 1) {
      setValue('siteId', response[0].value)
      setError('siteId', {})
      await getCampList(response[0].value as string)
    }
    setSites(response)
  }
  const getCampList = async (siteId: string) => {
    const response = await getCampFD({siteId: siteId})
    if (response.length === 1) {
      setValue('campamentoId', response[0].value)
      setError('campamentoId', {})
    }
    setCamps(response)
  }

  const getSupplierList = async () => {
    let obj: SupplierModel = {
      isCombo: true,
    }
    const response = await getSupplier(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.razonSocial}))
    setSupplier(mappedSites)
  }

  const getPointByIdValues = async () => {
    const response = await getPointById(currentTabItem.idToEdit)
    const data = response.data.data
    type PointModelKeys = keyof PointModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as PointModelKeys]) {
            if (fieldName === 'clienteId') {
              let valueCompania = data['companiaId']
              let valueClient = data['clienteId']
              getClientList(valueCompania as any)
              setValue('clienteId', valueClient)
            } else if (fieldName === 'siteId') {
              let valueSite = data['siteId']
              let valueClient = data['clienteId']
              getSiteList(valueClient as any)
              setValue('siteId', valueSite)
            } else if (fieldName === 'campamentoId') {
              let valueSite = data['campamentoId']
              let valueClient = data['siteId']
              getCampList(valueClient as any)
              setValue('campamentoId', valueSite)
            } else if (fieldName === 'campoadicionalFec1') {
              let valueDep = data[fieldName as PointModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'campoadicionalFec2') {
              let valueDep = data[fieldName as PointModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else {
              setValue(fieldName, data[fieldName as PointModelKeys])
            }
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }

  useEffect(() => {
    getCompanyList()
    getTypeAdminList()
    getStatusUserList()
    getSupplierList()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getPointByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
    }
    reset()
    changeCurrentTabItem(obj)
  }

  const handleGetClient = (e: any) => {
    let value = e.value
    getClientList(value)
    setValue('companiaId', value)
    setError('companiaId', {})
    clearFields(setValue, setError, {
      clienteId: '',
      siteId: '',
      campamentoId: '',
    })
  }
  const handleGetSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    setValue('clienteId', value)
    setError('clienteId', {})
    clearFields(setValue, setError, {
      siteId: '',
      campamentoId: '',
    })
  }
  const handleGetCamp = (e: any) => {
    let value = e.value
    getCampList(value)
    setValue('siteId', value)
    setError('siteId', {})
    clearFields(setValue, setError, {
      campamentoId: '',
    })
  }

  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_form card p-4'>
      <HeaderTitle title={TITLE_FORM_POINT} handleBack={handleBack} />
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Compañía'
            name='companiaId'
            data={company}
            disabled={isDisabled}
            onChangeValue={handleGetClient}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Cliente'
            name='clienteId'
            data={clients}
            disabled={isDisabled}
            onChangeValue={handleGetSite}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Site'
            name='siteId'
            data={sites}
            disabled={isDisabled}
            onChangeValue={handleGetCamp}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Campamento'
            name='campamentoId'
            data={camps}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Nomenclatura de Lavandería'
            name='nombre'
            textPlaceholder='Escribe la nomenclatura'
            type='ticketNumber'
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputNumberWrapper
            labelText='Capacidad de procesamiento diario en Kg'
            name='capacidadInstalada'
            textPlaceholder='Escribe la capacidad en Kg'
            type='decimal'
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputNumberWrapper
            labelText='Número de máquinas'
            name='cantidadMaquinas'
            textPlaceholder='Escribe el número'
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Tipo de Administración'
            name='tipoAdministracion'
            data={typeAdmin}
            required
          />
        </div>
        {watch('tipoAdministracion') === 'EXTERNO' && (
          <div className='col-sm-12 col-lg-3'>
            <SelectWrapper labelText='Proveedor' name='proveedorId' data={supplier} required />
          </div>
        )}
        {isDisabled && (
          <div className='col-sm-12 col-lg-3'>
            <SelectWrapper labelText='Estado' name='estado' data={statusUser} required />
          </div>
        )}
        <div className='col-sm-12 col-lg-3'>
          <label>Principal:</label>
          <Switch register={register} name='principal' errors={errors} />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </div>
  )
}

export default Point
